import speaker from '../../../../assets/images/Advertisement/speaker.png'
import watch from '@assets/images/Advertisement/watch.png'
import envelop from '@assets/images/Advertisement/envelope.png'
import desktop from '@assets/images/Advertisement/analytics.png'
import target from '@assets/images/Advertisement/target.png'
import styles from '@shared/components/Advertisement/HomePage.module.scss'
import React from 'react'

import MyImage from '@shared/components/myImage'

const features = [
  {
    image: speaker,
    title: '40 Million+',
    description: 'Monthly Pageview'
  },
  {
    image: watch,
    title: '3 min 21 secs',
    description: 'Average Time Spent on Website'
  },
  {
    image: envelop,
    title: '2 Million+',
    description: 'Monthly Traffic on Predictions'
  },
  {
    image: target,
    title: '82%',
    description: 'Traffic from India'
  },
  {
    image: desktop,
    title: '72%',
    description: 'New Visitors'
  }
]

const FeatureCard = () => {
  return (
    <div className={styles.featureContainer}>
      {features.map((data, i) => (
        <div className={styles.cardFeature} key={i}>
          <div className={styles.featureImg}>
            <MyImage src={data.image} alt="Rating" />
          </div>
          <span className={styles.featureTitle}>{data.title}</span>
          <span className={styles.featureDesp}>{data.description}</span>
        </div>
      ))}
    </div>
  )
}

export default FeatureCard
